import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Application } from './pages/Application';
import { OnboardingPage } from './pages/OnboardingPage';
import { SplashPage } from './pages/SplashPage';
import { EmailVerificationPage } from './pages/EmailVerificationPage';
import { LandingPage } from './pages/LandingPage';
import { LogoOptions } from './pages/LogoOptions';
import { PersonalizationPage } from './pages/PersonalizationPage';
import { ManageSchedulePage } from './pages/ManageSchedulePage';
import { FriendsAndCirclesPage } from './pages/FriendsAndCirclesPage';
import { DiscoverPage } from './pages/DiscoverPage';
import { NotificationsPage } from './pages/NotificationsPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/partner/splash" element={<SplashPage data-id="element-5" />} data-id="element-4" />
        <Route path="/app" element={<Application data-id="element-7" />} data-id="element-6" />
        <Route path="/app/discover" element={<DiscoverPage data-id="element-9" />} data-id="element-8" />
        <Route path="/app/personalize" element={<PersonalizationPage data-id="element-11" />} data-id="element-10" />
        <Route path="/app/schedule" element={<ManageSchedulePage data-id="element-13" />} data-id="element-12" />
        <Route path="/app/friends" element={<FriendsAndCirclesPage data-id="element-15" />} data-id="element-14" />
        <Route path="/app/notifications" element={<NotificationsPage data-id="element-17" />} data-id="element-16" />
        <Route path="/onboard/setup" element={<OnboardingPage data-id="element-19" />} data-id="element-18" />
        {/* <Route
          path="/email-verification-preview"
          element={<EmailVerificationPage />}
         /> */}
        {/* <Route path="/logo-options" element={<LogoOptions />} /> */}
      </Routes>
    </BrowserRouter>;
}